// ==== Dawn Mobile Drawer → Accordion Mode (Fixed, Clean, Chevron Compatible) ====
// Turns Dawn's drilldown into accordion without duplicating Liquid sections.
// Keeps parent items clickable toggles with smooth open/close behavior.

(function () {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  function init() {
    const drawer = document.getElementById('menu-drawer');
    const detailsContainer = document.getElementById('Details-menu-drawer-container');
    if (!drawer || !detailsContainer) return;

    // Find parent items that have drilldown targets
    const parentTriggers = drawer.querySelectorAll(
      'a.menu-drawer__menu-item[aria-controls], summary.menu-drawer__menu-item[aria-controls]'
    );

    parentTriggers.forEach((trigger) => {
      const panelId = trigger.getAttribute('aria-controls');
      if (!panelId) return;

      const parentLI = trigger.closest('li');
      if (!parentLI || parentLI.classList.contains('mm-accordion-ready')) return;

      parentLI.classList.add('mm-accordion-ready', 'mm-has-sub');
      parentLI.style.position = 'relative'; // ← ensures ::after (chevron) renders properly

      const panel = drawer.querySelector('#' + CSS.escape(panelId));
      if (!panel) return;

      const submenuList =
        panel.querySelector('.menu-drawer__menu') ||
        panel.querySelector('ul, ol');
      if (!submenuList) return;

      // Clone submenu contents (shallow clone)
      const mount = document.createElement('div');
      mount.className = 'mm-sub';
      const clone = submenuList.cloneNode(true);
      clone.removeAttribute('id');
      mount.appendChild(clone);
      parentLI.appendChild(mount);

      // Toggle behavior
      trigger.addEventListener('click', (ev) => {
        ev.preventDefault();
        ev.stopPropagation();

        const isOpen = parentLI.classList.toggle('mm-open');
        mount.style.display = isOpen ? 'block' : 'none';

        // Close all siblings (single-open behavior)
        if (isOpen) {
          const siblings = Array.from(parentLI.parentElement.children).filter(
            (n) => n !== parentLI
          );
          siblings.forEach((sib) => {
            sib.classList.remove('mm-open');
            const sibSub = sib.querySelector(':scope > .mm-sub');
            if (sibSub) sibSub.style.display = 'none';
          });
        }
      });

      // Start collapsed
      parentLI.classList.remove('mm-open');
      mount.style.display = 'none';
    });

    // Optional: close drawer on ESC key
    drawer.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && detailsContainer.hasAttribute('open')) {
        detailsContainer.removeAttribute('open');
        e.stopPropagation();
      }
    });
  }
})();

// Dawn Mobile Drawer → Stable Accordion without drilldown
// - Moves drilldown panels inline into <details>
// - Removes aria-controls so Dawn's slide logic is disabled
// - Uses <details open> for state (compatible with CSS chevrons)
// - Closes siblings (single-open)

(function () {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  function init() {
    const drawer = document.getElementById('menu-drawer');
    const detailsContainer = document.getElementById('Details-menu-drawer-container');
    if (!drawer || !detailsContainer) return;

    // Find all first-level <details> items in the drawer menu
    const detailItems = drawer.querySelectorAll(
      '.menu-drawer__navigation details, #menu-drawer details'
    );

    detailItems.forEach((detailsEl) => {
      if (detailsEl.__mmReady) return;

      const summary = detailsEl.querySelector('summary.menu-drawer__menu-item');
      if (!summary) return;

      // If Dawn wired this to a slide panel, pull that panel inline and disable drilldown
      const panelId = summary.getAttribute('aria-controls');
      if (panelId) {
        const panel = drawer.querySelector('#' + CSS.escape(panelId));
        if (panel) {
          // find list inside the panel
          const srcList = panel.querySelector('.menu-drawer__menu, ul, ol');
          if (srcList) {
            // mount inline (only if not already present)
            const hasInline = detailsEl.querySelector(':scope > .menu-drawer__menu, :scope > ul, :scope > ol, :scope > .mm-sub');
            if (!hasInline) {
              const mount = document.createElement('div');
              mount.className = 'mm-sub';
              const clone = srcList.cloneNode(true);
              clone.removeAttribute('id');
              mount.appendChild(clone);
              detailsEl.appendChild(mount);
            }
          }
        }

        // Disable Dawn's drilldown by removing control attributes
        summary.removeAttribute('aria-controls');
        summary.removeAttribute('aria-expanded');
        // Optional: remove href on nested <a> inside summary, if any
        const a = summary.querySelector('a');
        if (a) {
          a.setAttribute('data-mm-orig-href', a.getAttribute('href') || '');
          a.setAttribute('href', '#');
        }
      }

      // Ensure positioning for CSS ::after chevron
      detailsEl.style.position = detailsEl.style.position || 'relative';

      // Stable toggle: use native <details> open
      summary.addEventListener(
        'click',
        (e) => {
          // Prevent any leftover handlers from Dawn (since we removed aria-controls, this is just safety)
          e.preventDefault();
          e.stopPropagation();

          const willOpen = !detailsEl.open;
          // Close siblings for single-open behavior
          const li = detailsEl.closest('li');
          if (li && li.parentElement) {
            [...li.parentElement.children].forEach((sib) => {
              if (sib !== li) {
                const sibDetails = sib.querySelector(':scope > details');
                if (sibDetails) sibDetails.open = false;
              }
            });
          }
          detailsEl.open = willOpen;
        },
        true
      );

      detailsEl.__mmReady = true;
    });

    // Safety: if there are anchors (outside summary) that still have aria-controls, neutralize them
    drawer.addEventListener(
      'click',
      (e) => {
        const link = e.target.closest('a.menu-drawer__menu-item[aria-controls]');
        if (!link) return;
        e.preventDefault();
        e.stopPropagation();
        // Try to find its sibling <details> or parent details
        const parentLi = link.closest('li');
        const detailsEl =
          (parentLi && parentLi.querySelector(':scope > details')) || link.closest('details');
        if (detailsEl) {
          // toggle like summary
          const willOpen = !detailsEl.open;
          // close siblings
          const li = detailsEl.closest('li');
          if (li && li.parentElement) {
            [...li.parentElement.children].forEach((sib) => {
              if (sib !== li) {
                const sibDetails = sib.querySelector(':scope > details');
                if (sibDetails) sibDetails.open = false;
              }
            });
          }
          detailsEl.open = willOpen;
        }
      },
      true
    );

    // ESC closes drawer
    drawer.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && detailsContainer.hasAttribute('open')) {
        detailsContainer.removeAttribute('open');
        e.stopPropagation();
      }
    });
  }
})();

